import React from "react";

import logo from "../../../images/Damas_univ.png";
import { Col, Row } from "../../../ApiS/Grid-system/Grid-system";
import Title from "../../Title/Title";
import Selected from "../../Inputs/Selected";
import Input from "../../Inputs/Input";
import MainButton from "../../Buttons/MainButton";

interface Option {
  id: string;
  name: string;
  type: string;
}

export default function Enter_Decisions() {
  // const [selectedOptionType, setSelectedOptionType] = useState<string | null>(null);
  // const [dataPayment, setDataPayment] = useState<{ data: { data: Option[] } | null >(null);

  // const handleChangeInput = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
  //   // your logic here
  // };

  return (
    <>
      <Row>
        <Col>
          <Title title="ادخال قرارات" />
        </Col>
      </Row>
      <Row justify={"center"}>
        <Col lg={11} sm={11}>
          <Selected
            title=" القرار"
            //   name="payment_method_id"
            // text="أختر اسم المقرر"
            value={""}
            onChange={(e) => {
              //   handleChangeInput(e);
              // setSelectedOptionType(e.target.options[e.target.selectedIndex].dataset.type)
            }}
            className=" max-lg:!w-full mb-5"
          >
            {/* {dataPayment?.data?.data?.map((e) => ( */}
            <option
            // key={e.id} value={e.id} data-type ={e.type}
            >
              {/* {e.name} */}
              000000
            </option>
            {/* ))} */}
            <option>111111</option>
            <option>222222</option>
            <option>333333</option>
          </Selected>
        </Col>
      </Row>

      <Row>
        <Col lg={12} className="mx-5">
          <div>
            <img
              src={logo}
              alt="xxx"
              className="w-24 h-24 border-2 rounded-full"
            />
          </div>
        </Col>
        <Col lg={12} className="mx-7">
          <div className="text-lg font-bold ">أحمد الأحمد</div>
        </Col>
      </Row>

      <Row justify={"around"}>
        <Col lg={5} md={5} sm={11}>
          <Input
            placeholder="اسم الاب"
            className="!bg-white !border-2 border-Secondary"
          />
        </Col>
        <Col lg={5} md={5} sm={11}>
          <Input
            placeholder="اسم الأم"
            className="!bg-white !border-2 border-Secondary"
          />
        </Col>
        <Col lg={5} md={5} sm={11}>
          <Input
            placeholder="مكان الميلاد"
            className="!bg-white !border-2 border-Secondary"
          />
        </Col>
        <Col lg={5} md={5} sm={11}>
          <Input
            placeholder=" تاريخ الميلاد"
            className="!bg-white !border-2 border-Secondary"
          />
        </Col>
        <Col lg={5} md={5} sm={11}>
          <Input
            placeholder=" الرقم الوطني"
            className="!bg-white !border-2 border-Secondary"
          />
        </Col>
        <Col lg={5} md={5} sm={11}>
          <Input
            placeholder=" مكان القيد"
            className="!bg-white !border-2 border-Secondary"
          />
        </Col>
        <Col lg={5} md={5} sm={11}>
          <Input
            placeholder="رقم القيد"
            className="!bg-white !border-2 border-Secondary"
          />
        </Col>
        <Col lg={5} md={5} sm={11}>
          <Input
            placeholder=" نوع الثانوية "
            className="!bg-white !border-2 border-Secondary"
          />
        </Col>

        <Col lg={5} md={5} sm={11}>
          <Input
            placeholder="عام الثانوية"
            className="!bg-white !border-2 border-Secondary"
          />
        </Col>
        <Col lg={5} md={5} sm={11}>
          <Input
            placeholder=" جهة الاصدار "
            className="!bg-white !border-2 border-Secondary"
          />
        </Col>
        <Col lg={5} md={5} sm={11}>
          <Input
            placeholder="اسم البرنامج"
            className="!bg-white !border-2 border-Secondary"
          />
        </Col>
        <Col lg={5} md={5} sm={11}>
          <Input
            placeholder=" معدل التفاضل "
            className="!bg-white !border-2 border-Secondary"
          />
        </Col>
      </Row>

      <Row className="!mt-5">
        <Col>
          <Title title="ادخال القرار" />
        </Col>
      </Row>

      <Row justify={"around"}>
        <Col lg={5} md={5} sm={11}>
          <Input placeholder="رقم القرار " className="!bg-Main  " />
        </Col>
        <Col lg={5} md={5} sm={11}>
          <Input placeholder=" " className="!bg-Main  " type={"date"} />
        </Col>
        <Col lg={5} md={5} sm={11}>
          <Input placeholder="موضوع القرار " className="!bg-Main  " />
        </Col>
        <Col lg={5} md={5} sm={11}>
          {/* <AddImage
            type="IMAGES"
            accept=" application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
            title="صورة القرار"
            name="file"
            className="!bg-Main "
            onChange={(e) => {
              // setSuccessPost(0);
              // handleChangeInput(e);
            }}
          /> */}
        </Col>
        <Col lg={5} md={5} sm={11}>
          {/* empty column */}
        </Col>

        <Col
          lg={6}
          md={5}
          sm={11}
          className="flex lg:justify-end max-lg:mx-auto  !mt-4 "
        >
          <MainButton titlebtn="تأكيد" className="w-[400px] mb-10" />
        </Col>
      </Row>
    </>
  );
}
